import styled, { css } from 'styled-components';

export const DateTimeEditWrapper = styled.div<{ shouldDisplay: boolean }>`
  @keyframes slideIn {
    0% {
      opacity: 0;
      visibility: hidden;
    }

    100% {
      opacity: 1;
      visibility: visible;
    }
  }

  margin-bottom: 16px;
  animation: ${({ shouldDisplay }) => (shouldDisplay ? 'slideIn 0.3s ease-in-out' : '')} forwards;

  span {
    display: ${({ shouldDisplay }) => (shouldDisplay ? 'block' : 'none')};
  }

  @media (max-width: 1200px) {
    padding: 0 20px;
  }
`;

export const DateTimeEditContainer = styled.div``;

export const DateEditContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
`;

export const DateTitle = styled.span`
  font-size: 18px;
  font-weight: 600;
`;

export const DateEditButton = styled.button`
  span {
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
  }
`;

export const BottomLineContainer = styled.div`
  margin-bottom: 40px;
`;

export const SessionButton = styled.button<{ disabled: boolean; selected?: boolean; completed?: boolean }>`
  background-color: var(--white);
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  padding: 0 20px;
  border: solid 1px transparent;
  white-space: nowrap;
  text-overflow: ellipsis;
  span {
    font-size: 18px;
    font-weight: 600;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      border-radius: 15px;
      cursor: not-allowed;
      span {
        color: var(--text-primary);
      }
    `}

  ${({ selected }) =>
    selected &&
    css`
      border: solid 1px var(--black);
      span {
        color: var(--text-primary);
      }
    `}

  ${({ completed }) =>
    completed &&
    css`
      background-color: var(--black);
      span {
        color: var(--white);
      }
    `}
`;
